<template>
  <MainLayout>
    <div
      style="
        height: 100%;
        background-color: white;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        padding-left: var(--sidebar-width);
        padding-top: var(--nav-height);
      "
    >
      <iframe
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
        allowfullscreen="true"
        :src="src"
        style="display: block; height: 100%; overflow: auto; width: 100%; border: none"
      />
    </div>
  </MainLayout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DriveIframe',
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/drive-iframe`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      if (event.data.event_id === 'select_file_drive_payload' && event.data.value[0].url) {
        window.open(event.data.value[0].url, '_blank')
      }
      if (event.data.event_id === 'copy_to_clipboard') {
        navigator.clipboard.writeText(event.data.value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/DriveIframe/index.vue